import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { useAuth } from '../auth';

export function useShufersalCredentials() {
  const { user } = useAuth();
  const [hasCredentials, setHasCredentials] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const checkCredentials = async () => {
    if (!user) return;
    
    try {
      setLoading(true);
      console.log('Checking credentials for user:', user.id);
      
      const { data, error } = await supabase
        .from('user_shufersal_credentials')
        .select('id')
        .eq('user_id', user.id)
        .single();

      console.log('Credentials check result:', { data, error });

      if (error && error.code !== 'PGRST116') {
        throw error;
      }

      setHasCredentials(!!data);
    } catch (error) {
      console.error('Error checking Shufersal credentials:', error);
      setHasCredentials(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      console.log('User changed, checking credentials');
      checkCredentials();
    } else {
      setHasCredentials(false);
      setLoading(false);
    }
  }, [user]);

  const saveCredentials = async (shufersalEmail: string, shufersalPassword: string) => {
    if (!user) return;

    try {
      const { error } = await supabase
        .from('user_shufersal_credentials')
        .upsert({
          user_id: user.id,
          shufersal_email: shufersalEmail,
          shufersal_password: shufersalPassword,
        });

      if (error) throw error;
      setHasCredentials(true);
    } catch (error) {
      console.error('Error saving Shufersal credentials:', error);
      throw error;
    }
  };

  return {
    hasCredentials,
    loading,
    saveCredentials,
    checkCredentials,
  };
} 